import { XIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { LogoWithName } from '@/shared/components/theme/logo-with-name';
import { Button } from '@/shared/components/ui/button';

export const FlowHeader = ({
  children,
  onCancel,
}: {
  children?: React.ReactNode;
  onCancel: () => void;
}) => {
  const { t } = useTranslation('common');

  return (
    <div className="fixed left-12 right-12 top-12 flex flex-row items-start justify-between">
      <LogoWithName />
      <div className="flex flex-row gap-4">
        <Button variant={'outline'} btnType="secondary" onClick={onCancel}>
          <XIcon />
          {t('button.cancel')}
        </Button>
        {children}
      </div>
    </div>
  );
};
